import Hub from '../hub.js';
import EventDelegate from '../utils/event-delegate.js';

const Tracking = (function () {
    var MOUSE_LEFT = 1;
    var MOUSE_MIDDLE = 2;

    var dataAttr = {
        click: 'data-trc',
        event: 'data-tracking-event',
        tag: 'data-tracking-tag',
        measurement: 'data-tracking-ready',
        key: 'data-tracking-key',
        submit: 'data-tracking-submit'
    };

    var fieldName = {
        measurement: 'Measurement',
        values: 'Values',
        tags: 'Tags'
    };

    var Measurement = function () {
        this.data = {};
        this.data[fieldName.values] = {};
        this.data[fieldName.tags] = [];
    };

    Measurement.prototype = {
        setName: function (name) {
            var version = window.innerWidth < 1280 ? 'domodi.light.' : 'domodi.frontend.';
            this.data[fieldName.measurement] = version + name;
        },
        setValue: function (key, value) {
            var item = this.data[fieldName.values] = {};
            item[key] = value;
        },
        setTag: function (tag) {
            this.data[fieldName.tags].push(tag);
        },
        getData: function () {
            return this.data;
        }
    };

    var Stats = function () {
        this.addEvents();
        this.subscribe();
    };

    Stats.prototype = {
        splitTopic(str) {
            var param = str.split('.');
            var tags = [];
            for (var i = 2; i < param.length; i++) {
                if (param[i] !== '') {
                    tags.push(param[i]);
                }
            }
            return {
                measurement: param[0],
                key: param[1],
                tags: tags
            };
        },

        isMouseClick(e) {
            return e.which === MOUSE_LEFT || e.which === MOUSE_MIDDLE;
        },

        write(measurement) {
            var data = [];

            if (typeof measurement.getData() === 'object') {
                data.push(measurement.getData());
            }

            DM.Service.Grafana.sendData(data)
        },

        handleClick(e) {
            var measurement = new Measurement();

            if (this.isMouseClick(e)) {

                measurement.setName(dataAttr.measurement);
                measurement.setValue(dataAttr.key, 1);

                if (dataAttr.tag) {
                    measurement.setTag(dataAttr.tag);
                }

                this.write(measurement);
            }
        },

        handleClickAttr(e) {
            var element = e.currentTarget;

            if (this.isMouseClick(e.originalEvent)) {
                Hub.publish(Hub.TRACK_GRAFANA, element.getAttribute(dataAttr.click));
            }
        },

        handleView() {
            var tracked = [];
            var elements = document.querySelectorAll('[' + dataAttr.measurement + ']');

            [].forEach.call(elements, function (value) {
                var name = value.getAttribute(dataAttr.measurement);
                var measurement = new Measurement();

                if (tracked.indexOf(name) === -1) {
                    tracked.push(name);
                    measurement.setName(name);
                    measurement.setValue('pageView', 1);
                    this.write(measurement);
                }

            }.bind(this));
        },

        handleSubscribe(topic) {
            var param = this.splitTopic(topic);
            var measurement = new Measurement();

            if (param.measurement && param.key) {
                measurement.setName(param.measurement);
                measurement.setValue(param.key, 1);

                if (param.tags) {
                    for (var i = 0; i < param.tags.length; i++) {
                        measurement.setTag(param.tags[i]);
                    }
                }

                this.write(measurement);
            }
        },

        handleSubmit(e) {
            const element = e.currentTarget;
            Hub.publish(Hub.TRACK_GRAFANA, element.getAttribute(dataAttr.submit));
        },

        addEvents() {
            const delegate = new EventDelegate(document);
            delegate.on('click', '[' + dataAttr.click + ']', this.handleClickAttr.bind(this));
            delegate.on('submit', '[' + dataAttr.submit + ']', this.handleSubmit.bind(this));
            window.addEventListener('DOMContentLoaded', this.handleView.bind(this));
        },

        subscribe() {
            Hub.subscribe(Hub.TRACK_GRAFANA, this.handleSubscribe.bind(this));
        }
    };

    return new Stats();

})();

export default Tracking;
